export default "__VITE_ASSET__c1fb8ff8__"